(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[163],{

/***/ "bDgJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BolderArrowForthLeft", function() { return BolderArrowForthLeft; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var BolderArrowForthLeft = function BolderArrowForthLeft(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 500 844.3"
  }, rest), title && __jsx("title", null, title), __jsx("path", {
    d: "M444.9 0c14.1 0 28.2 5.4 38.9 16.1 21.5 21.5 21.5 56.4 0 77.9L155.7 422.2l328.2 328.1c21.5 21.5 21.5 56.4 0 77.9s-56.4 21.5-77.9 0L0 422.2l406-406C416.8 5.4 430.9 0 444.9 0z"
  }));
};

/***/ })

}]);